import { render } from "./HealthSafetyImg.vue?vue&type=template&id=72cf1471&scoped=true"
import script from "./HealthSafetyImg.vue?vue&type=script&lang=js"
export * from "./HealthSafetyImg.vue?vue&type=script&lang=js"

import "./HealthSafetyImg.vue?vue&type=style&index=0&id=72cf1471&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cf1471"]])

export default __exports__